// extracted by mini-css-extract-plugin
export var chevronIcon = "_4a-2";
export var teamName = "_4a-1";
export var teamSwitcherButton = "_4a-0";